var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#919191",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M16 22H7.429A1.433 1.433 0 0 1 6 20.571V3.43C6 2.643 6.643 2 7.429 2H16c.786 0 1.429.643 1.429 1.429V20.57c0 .786-.643 1.429-1.429 1.429"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  stroke: "#454545",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M17.429 4.857H6v12.857h11.429z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  stroke: "#DDD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M11.714 21.286a.714.714 0 1 0 0-1.43.714.714 0 0 0 0 1.43"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#454545",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M10.286 2.714h2.857"
})));
export default SvgIcPhone;